import store from '@/store'
const traderecord = () => import(/* webpackChunkName: "traderecord" */ '@/views/traderecord')
const periodManagement = () => import(/* webpackChunkName: "period-management" */ '@/views/period-management')
const openManagement = () => import(/* webpackChunkName: "open-management" */ '@/views/open-management')
const operator = () => import(/* webpackChunkName: "operator" */ '@/views/operator/list.vue')
// const cashMember = () => import('@/views/cash-member')
import noPermission from '@/views/no-permission'
const other = [
    {
        path: 'traderecord',
        name: 'traderecord',
        meta: { title: '操盘纪录' },
        component: traderecord,
        beforeEnter: (to, from, next) => {
            if (store.getters.getpermission.system[1] != '1') return next({ name: 'no-permission', params: to.params})
            next()
        },
    },
    {
        path: 'period-management',
        name: 'period-management',
        meta: { title: '期数管理' },
        component: periodManagement,
        beforeEnter: (to, from, next) => {
            if (store.getters.getpermission.period[0] != '1') return next({ name: 'no-permission', params: to.params})
            next()
        },
    },
    {
        path: 'open-management',
        name: 'open-management',
        meta: { title: '开奖管理' },
        component: openManagement,
        beforeEnter: (to, from, next) => {
            if (store.getters.getpermission.lottery[0] != '1') return next({ name: 'no-permission', params: to.params})
            next()
        },
    },
  
    {
        path: 'operator',
        name: 'operator',
        meta: { title: '操作员' },
        component: operator,
        beforeEnter: (to, from, next) => {
            if (store.getters.getpermission.operator[0] != '1') return next({ name: 'no-permission', params: to.params})
            next()
        },
    },
    {
        path: 'no-permission',
        name: 'no-permission',
        component: noPermission,
        meta: { title: '无权限' },
    },
    // {
    //     path: '/main/cash-member',
    //     name: 'cash-member',
    //     meta: { title: '现金会员' },
    //     component: cashMember,
    // }
]
export default other